module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "Room__main-container",
    class: {
      'aside-opened': _vm.aside
    }
  }, [_c('div', {
    staticClass: "Room__header"
  }, [_c('div', {
    staticClass: "Room__header-main"
  }, [_c('div', {
    staticClass: "Room__info"
  }, [_c('div', {
    staticClass: "Room__info-item"
  }, [_c('i', {
    staticClass: "icon-ic_link Room__icon-link"
  }), _vm._v("\n          " + _vm._s(_vm.conference.credentials.conferenceUrl) + "\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "Room__info-item"
  }, [_c('i', {
    staticClass: "icon-ic_lock Room__icon-lock"
  }), _vm._v("\n          PIN " + _vm._s(_vm.conference.credentials.conferencePin) + "\n        ")])]), _vm._v(" "), _c('div', {
    staticClass: "Room__call-info"
  }, [_c('div', {
    staticClass: "Room__call-info-timer"
  }, [_vm._v("\n          " + _vm._s(_vm.duration) + "\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "Room__call-info-participants"
  }, [_vm._v("\n          " + _vm._s(_vm.title) + "\n        ")])]), _vm._v(" "), _c('room-actions', {
    attrs: {
      "user": _vm.user,
      "conference": _vm.conference
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "Room__header-sub"
  }, [(!_vm.initializing && _vm.ownerIsPresent) ? _c('div', [_c('div', {
    staticClass: "Room__talking-participants"
  }, [_vm._v("\n          " + _vm._s(_vm.talking) + "\n        ")]), _vm._v(" "), (_vm.user.isOwner) ? _c('i', {
    staticClass: "icon-ic_mute-all Room__mute-all",
    on: {
      "click": _vm.muteAll
    }
  }) : _vm._e()]) : _vm._e(), _vm._v(" "), (!_vm.initializing && !_vm.ownerIsPresent) ? _c('div', {
    staticClass: "Room__header-missing-owner"
  }, [_vm._v("\n        Waiting for organizer (admin) to arrive…\n      ")]) : _vm._e()])]), _vm._v(" "), _c('div', {
    staticClass: "Room__body"
  }, [(_vm.ownerIsPresent) ? _c('div', {
    staticClass: "Room__body-background",
    style: ({
      'background-image': 'url(' + _vm.owner.avatarUrl + ')'
    })
  }) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "Room__body-background-overlay",
    class: {
      'missing-owner': !_vm.initializing && !_vm.ownerIsPresent
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "Room__body-container"
  }, [(!_vm.initializing) ? _c('div', {
    staticClass: "Room__participants",
    class: {
      'alone': _vm.participants.length === 1
    },
    attrs: {
      "name": "fade"
    }
  }, _vm._l((_vm.participants), function(participant, index) {
    return _c('div', {
      key: index,
      staticClass: "Room__participant",
      class: {
        admin: participant.isAdmin, muted: participant.isMuted, talking: participant.isTalking
      }
    }, [(_vm.getUserInfo(participant.userId).avatarUrl) ? _c('img', {
      staticClass: "Room__participant-avatar",
      attrs: {
        "src": _vm.getUserInfo(participant.userId).avatarUrl
      }
    }) : _c('img', {
      staticClass: "Room__participant-avatar Room__participant-avatar--default",
      attrs: {
        "src": require("../../../static/images/default-user-avatar.jpg")
      }
    }), _vm._v(" "), _c('div', {
      staticClass: "Room__participant-container"
    }, [_c('div', {
      staticClass: "Room__participant-toolbar"
    }, [_c('div', {
      staticClass: "Room__participant-info"
    }, [(participant.isAdmin) ? _c('i', {
      staticClass: "icon-ic_admin"
    }) : _vm._e(), _vm._v(" "), (participant.isMuted) ? _c('i', {
      staticClass: "icon-ic_muted"
    }) : _vm._e(), _vm._v(" "), (false) ? _c('i', {
      staticClass: "icon-ic_handup"
    }) : _vm._e()]), _vm._v(" "), (_vm.user.isAdmin & _vm.user.userId !== participant.userId) ? _c('participant-more-menu', {
      attrs: {
        "user": participant,
        "name": _vm.getUserInfo(participant.userId).name
      }
    }) : _vm._e()], 1), _vm._v(" "), _c('div', {
      staticClass: "Room__participant-name"
    }, [_vm._v("\n              " + _vm._s(_vm.getUserInfo(participant.userId).name) + "\n            ")])])])
  })) : _vm._e(), _vm._v(" "), (_vm.initializing) ? _c('i', {
    staticClass: "icon-ic_spinner Room__initializing-spinner"
  }) : _vm._e()]), _vm._v(" "), _c('audio', {
    staticClass: "hidden",
    attrs: {
      "src": _vm.localStreamSrc,
      "id": "localStream",
      "autoplay": "",
      "controls": "",
      "muted": ""
    }
  }), _vm._v(" "), _c('audio', {
    staticClass: "hidden",
    attrs: {
      "src": _vm.remoteStreamSrc,
      "id": "remoteStream",
      "autoplay": "",
      "controls": ""
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "Room__footer"
  }, [_c('transition', {
    attrs: {
      "name": "appear-from-bottom"
    }
  }, [(_vm.participants.length) ? _c('div', {
    staticClass: "Room__footer-actions"
  }, [_c('div', {
    staticClass: "Room__footer-action",
    on: {
      "click": _vm.openSettings
    }
  }, [_c('div', {
    staticClass: "Room__footer-action-btn"
  }, [_c('i', {
    staticClass: "icon-ic_settings"
  })]), _vm._v(" "), _c('div', {
    staticClass: "Room__footer-action-description"
  }, [_vm._v("\n          Settings\n        ")])]), _vm._v(" "), _c('div', {
    staticClass: "Room__footer-action",
    on: {
      "click": _vm.mute
    }
  }, [_c('div', {
    staticClass: "Room__footer-action-btn",
    class: {
      'active': _vm.user.isMuted
    }
  }, [_c('i', {
    staticClass: "icon-ic_mute"
  })]), _vm._v(" "), _c('div', {
    staticClass: "Room__footer-action-description"
  }, [_vm._v("\n          " + _vm._s(_vm.user.isMuted ? 'Muted' : 'Mute') + "\n        ")])]), _vm._v(" "), (_vm.user.isOwner) ? _c('div', {
    staticClass: "Room__footer-action",
    on: {
      "click": _vm.lock
    }
  }, [_c('div', {
    staticClass: "Room__footer-action-btn",
    class: {
      'active': _vm.conference.status.locked
    }
  }, [_c('i', {
    staticClass: "icon-ic_lock-call"
  })]), _vm._v(" "), _c('div', {
    staticClass: "Room__footer-action-description"
  }, [_vm._v("\n          " + _vm._s(_vm.conference.status.locked ? 'Locked' : 'Lock') + "\n        ")])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "Room__footer-action",
    class: {
      'invalidate': _vm.endCallInProcess
    },
    on: {
      "click": _vm.end
    }
  }, [_c('div', {
    staticClass: "Room__footer-action-btn Room__end-call-btn"
  }, [_c('i', {
    staticClass: "icon-ic_call_end Room__end-call-icon"
  })]), _vm._v(" "), _c('div', {
    staticClass: "Room__footer-action-description"
  }, [_vm._v("\n          " + _vm._s(_vm.user.isOwner ? 'End Call' : 'Leave Call') + "\n        ")])])]) : _vm._e()])], 1), _vm._v(" "), _c('transition', {
    attrs: {
      "name": "slide-right"
    }
  }, [_c(_vm.aside, {
    tag: "div",
    staticClass: "Room__aside"
  })]), _vm._v(" "), _c('settings-modal'), _vm._v(" "), _c('set-title-modal'), _vm._v(" "), _c('notification-modal'), _vm._v(" "), _c('page-title', {
    attrs: {
      "title": _vm.pageTitle
    }
  })], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-0057fee5","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/room/room.vue
// module id = 414
// module chunks = 1